import type { Id, Item } from './types'

export const updateItem = <T extends Item<Id>>(items: T[], target: T): T[] => {
  return items.map((item) => (item.id === target.id ? target : item))
}

export const updateItems = <T extends Item<Id>>(
  items: T[],
  newItems: T[],
): T[] => {
  const updatesMap = new Map(newItems.map((item) => [item.id, item]))
  return items.map((item) => updatesMap.get(item.id) ?? item)
}
